import { STATUS_DOT_CLASS, STATUS_LABELS } from './IssueRow'
import type { SystemIssueStatus } from '../../types/system-issues'

const PILL_CLASS: Record<SystemIssueStatus, string> = {
  open: 'bg-green-50 text-green-700 dark:bg-green-900/25 dark:text-green-300',
  pending: 'bg-orange-50 text-orange-700 dark:bg-orange-900/25 dark:text-orange-300',
  in_progress: 'bg-blue-50 text-blue-700 dark:bg-blue-900/25 dark:text-blue-300',
  improvement_suggestion: 'bg-purple-50 text-purple-700 dark:bg-purple-900/25 dark:text-purple-300',
  resolved: 'bg-teal-50 text-teal-700 dark:bg-teal-900/25 dark:text-teal-300',
}

/** Selo de status ao lado do título do chamado ("● Em andamento"). */
export function IssueStatusPill({ status }: { status: SystemIssueStatus }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-sm font-semibold ${PILL_CLASS[status]}`}
    >
      <span className={`h-2 w-2 shrink-0 rounded-full ${STATUS_DOT_CLASS[status]}`} aria-hidden />
      {STATUS_LABELS[status]}
    </span>
  )
}
